const StanaloneSelect = {
  mounted() {
    let eventName = this.el.dataset["eventName"] || "select_changed"
    this.el.addEventListener('change', () => {
      this.pushEventTo(this.el, eventName, {value: this.el.value})
    })
  }
}

export default { StanaloneSelect }
